import React, { FC, memo, useContext, useState } from 'react'
import { useSelector } from 'react-redux'
import { Box } from '@material-ui/core'
import Button from 'components/base/Button'
import { ConfirmationDialog } from 'components/base/ConfirmationDialog/ConfirmationDialog'
import { FormContext } from 'contexts/FormContext'
import { selectViewSettings } from 'selectors/mainView'
import { ViewSettings } from 'config/constants/editorSettings'

interface IProps {
  t(str: string): string
  activeMenuItem: string
}

export const Footer:FC<IProps> = memo(({ t, activeMenuItem }) => {
  const { resetForm } = useContext(FormContext)
  const viewSettings = useSelector(selectViewSettings)
  const [ showResetConfirm, setShowResetConfirm ] = useState(false)
  const currentLang = viewSettings[ViewSettings.lang] || ''

  const handleResetClick = () => {
    if (currentLang) {
      setShowResetConfirm(true)
      return
    }
    resetForm(activeMenuItem)
  }

  const confirmReset = () => {
    setShowResetConfirm(false)
    resetForm(activeMenuItem)
    window.location.reload()
  }

  return (
    <Box display="flex" justifyContent="flex-end" className="editor-settings__footer">
      <Button
        className="btn--border"
        onClick={handleResetClick}
      >
        {t('COMMON_RESET_ALL_CHANGES')}
      </Button>
      {showResetConfirm && (
        <ConfirmationDialog
          title={t('MODAL_WINDOW_LANGUAGE_CHANGE_TITLE')}
          confirmBtnText={t('MODAL_WINDOW_BUTTON_RESTART')}
          closeBtnText={t('EDITOR_MAIN_SETTINGS_BTN_CANCEL')}
          onCancel={() => setShowResetConfirm(false)}
          onConfirm={confirmReset}
        />
      )}
    </Box>
  )
})
